import React from "react";
import { Box, Typography } from "@mui/material";

export default function PageHeader({ icon, title, subtitle, action }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: { xs: "flex-start", sm: "center" },
        flexDirection: { xs: "column", sm: "row" },
        gap: 1.5,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, flex: 1, minWidth: 0 }}>
        {icon && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              borderRadius: 1,
              backgroundColor: "rgba(255,255,255,0.12)",
              border: "1px solid rgba(255,255,255,0.18)",
              color: "#fff",
              flexShrink: 0,
            }}
          >
            {React.cloneElement(icon, { sx: { fontSize: 18, ...(icon.props?.sx || {}) } })}
          </Box>
        )}
        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              color: "#fff",
              fontWeight: 600,
              letterSpacing: -0.2,
              lineHeight: 1.2,
              fontSize: { xs: "1rem", md: "1.125rem" },
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              sx={{
                color: "rgba(255,255,255,0.65)",
                fontSize: "0.75rem",
                lineHeight: 1.3,
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
      {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
    </Box>
  );
}
